"use strict";

var _require = require("./xl-utils.js"),
  parseRange = _require.parseRange,
  stringifyRange = _require.stringifyRange;
var _require2 = require("lodash"),
  cloneDeep = _require2.cloneDeep;
module.exports = function (relM) {
  var tables = [];
  relM.updateRef = function (rowStart, rowEnd) {
    tables.forEach(function (table) {
      if (table.initialRange[0].row === rowStart) {
        table.changed = true;
        table.range[0].row = rowEnd;
      }
      if (table.initialRange[1].row === rowStart) {
        table.changed = true;
        table.range[1].row = rowEnd;
      }
    });
  };
  relM.syncRefs = function () {
    tables.forEach(function (table) {
      if (table.changed) {
        if (table.autofilter) {
          table.autofilter.setAttribute("ref", stringifyRange(table.range));
        }
        table.xml.setAttribute("ref", stringifyRange(table.range));
      }
    });
  };
  relM.addTablePart = function (rId) {
    var path = relM.getRelationshipFullTarget(rId);
    var xmldoc = relM.xmlDocs[path];
    var xmlTable = xmldoc.getElementsByTagName("table")[0];
    var autofilter = xmldoc.getElementsByTagName("autoFilter");
    var ref = xmlTable.getAttribute("ref");
    var initialRange = parseRange(ref);
    var table = {
      changed: false,
      path: "/".concat(path),
      ref: ref,
      initialRange: initialRange,
      range: cloneDeep(initialRange),
      xml: xmlTable,
      xmldoc: xmldoc
    };
    if (autofilter.length !== 0) {
      table.autofilter = autofilter[0];
    }
    tables.push(table);
    relM.myTables = tables;
  };
  return relM;
};